import { Action } from '@ngrx/store';
import { AuthReducer, MfaDetails } from '../models/auth.model';

export enum ActionTypes {
  SIGN_IN = 'SIGN_IN',
  SIGN_OUT = 'SIGN_OUT',
  UPDATE_EMAIL = 'UPDATE_EMAIL',
  UPDATE_AUTH_TOKEN = 'UPDATE_AUTH_TOKEN',
  UPDATE_REFRESH_TOKEN = 'UPDATE_REFRESH_TOKEN',
  UPDATE_SIGNIN_RESPONSE = 'UPDATE_SIGNIN_RESPONSE',
  UPDATE_AUTHENTICATION_METHOD = 'UPDATE_AUTHENTICATION_METHOD',
  UPDATE_AUTHENTICATION_METHOD_INTERNAL_HANDLING = 'UPDATE_AUTHENTICATION_METHOD_INTERNAL_HANDLING',
}

export class SignIn implements Action {
  readonly type = ActionTypes.SIGN_IN;
  constructor(public payload: AuthReducer) {}
}

export class SignOut implements Action {
  readonly type = ActionTypes.SIGN_OUT;
}

export class UpdateEmail implements Action {
  readonly type = ActionTypes.UPDATE_EMAIL;
  constructor(public payload: string) {}
}

export class UpdateAuthToken implements Action {
  readonly type = ActionTypes.UPDATE_AUTH_TOKEN;
  constructor(public payload: string) {}
}

export class UpdateRefreshToken implements Action {
  readonly type = ActionTypes.UPDATE_REFRESH_TOKEN;
  constructor(public payload: string) {}
}

export class UpdateSignInResponse implements Action {
  readonly type = ActionTypes.UPDATE_SIGNIN_RESPONSE;
  constructor(public payload: MfaDetails) {}
}

export class UpdateAuthenticationMethod implements Action {
  readonly type = ActionTypes.UPDATE_AUTHENTICATION_METHOD;
  constructor(public payload: boolean) {}
}

export class UpdateAuthenticationMethodInternalHandling implements Action {
  readonly type = ActionTypes.UPDATE_AUTHENTICATION_METHOD_INTERNAL_HANDLING;
  constructor(public payload: string) {}
}

export type Actions =
  | SignIn
  | SignOut
  | UpdateEmail
  | UpdateAuthToken
  | UpdateRefreshToken
  | UpdateSignInResponse
  | UpdateAuthenticationMethod
  | UpdateAuthenticationMethodInternalHandling;
